const ContextType = {
    "id": 1,
    "climate": {
        "state": "Texas",
        "annualPrecipitationDays": 30,
        "precipitationThreshold": 0.1,
        "solarRadiation": 200,
    },
    "costParameters": {
        "state": "Texas",
        "asphaltPrice": 117.45, // $/yd^3
        "concretePrice": 150.00, // $/yd^3
        "dieselPrice": 3.07,
        "gasPrice": 2.64,
        "annualDiscountRate": 1.41,
    },
    "functionAndReliability": {
        "urbanRural": "Urban",
        "functionalSystem": "Interstate",
        "reliability": "High",
    },
    "trafficContent": {
        "trafficVolume": "High",
        "truckPercentage": "High",
        "trafficDirection": "Two-way",
        "trafficSpeed": "High",
        "trafficGrowth": "High",
        "numberLanes": 4,
        "pavementLength": 1,
        "shoulderType":"AC Shoulder",
        "shoulderWidth": 10,
    },

    "aadtPerLane": {
        "value": 6900,
        "min": 1000,
        "max": 1000,
        "mean": 1000,
        "distribution": "Uniform",
    },
    "aadtAllLane": {
        "min": 4000,
        "max": 4000,
        "mean": 4000,
        "distribution": "Uniform",
    },
    "truckPercentage": {
        "min": 10,
        "max": 10,
        "mean": 10,
        "distribution": "Uniform",
    },
    "aadttPerLane": {
        "min": 100,
        "max": 100,
        "mean": 100,
        "distribution": "Uniform",
    },
    "aadttAllLane": {
        "min": 400,
        "max": 400,
        "mean": 400,
        "distribution": "Uniform",
    },
    "trafficGrowth": {
        "min": 1,
        "max": 3,
        "mean": 2,
        "distribution": "Uniform",
    },
    "trafficSpeed": {
        "min": 35,
        "max": 55,
        "mean": 50,
        "distribution": "Uniform",
    },
    "reliability": {
        "min": 50,
        "max": 60,
        "mean": 55,
        "distribution": "Uniform",
    },
};

export default ContextType;
